import MiniOrchService from '~packages/miniorch-service';

import apiMiddlewares from '@/api/client/middlewares';
import getConstants from '@/shared/constants';

export const useMiniOrchService = () => {
  const { getVars } = getConstants();
  const vars = getVars();

  const miniOrchService = new MiniOrchService(
    {
      clientId: vars.VITE_MINIORCH_KC_CLIENT_ID,
      clientSecret: vars.VITE_MINIORCH_KC_CLIENT_SECRET,
      serverRealm: vars.VITE_MINIORCH_KC_REALM ?? vars.VITE_APP_KC_REALM,
      serverUrl: vars.VITE_MINIORCH_KC_URL ?? vars.VITE_APP_KC_URL,
    },
    {
      userName: vars.VITE_MINIORCH_KC_USER_NAME,
      userPass: vars.VITE_MINIORCH_KC_USER_PASS,
    },
    vars.VITE_MINIORCH_ENDPOINT,
    apiMiddlewares
  );

  return miniOrchService;
};
